module.exports = __webpack_public_path__ + "static/img/buxi.b49a5c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/buxi.jpg
// module id = wwa4
// module chunks = 1